import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-credit-card-items.presenters.CreditCardItemListPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to load the credit card items.',
  },
})
